/**
 * Renders a money amount. Accepts cents (integer) by default — using cents
 * everywhere internally avoids floating-point drift on totals.
 *
 *   <FormatMoney cents={5432100} />        → "$54,321.00"
 *   <FormatMoney cents={-150000} />        → "-$1,500.00"
 *   <FormatMoney cents={5000} currency="EUR" /> → "€50.00"
 */
export function FormatMoney({
  cents,
  currency = 'USD',
  signed = false,
}: {
  cents: number;
  currency?: string;
  signed?: boolean;
}) {
  const value = cents / 100;
  const formatted = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    signDisplay: signed ? 'always' : 'auto',
  }).format(value);
  return <span className="tabular-nums">{formatted}</span>;
}
